import React, { useEffect, useState } from "react";
import { EFMESystemSettings } from "../../models";
import { SystemSettingsService } from "../../services/SubmissionService";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

export default function SystemSettingsCard(): JSX.Element {
    const [systemSettings, setSystemSettings] = useState<EFMESystemSettings>(
        {} as EFMESystemSettings
    );

    useEffect(() => {
        SystemSettingsService.get().then((res: any) => {
            if (res && res.data && res.successful) {
                setSystemSettings(res.data);
            } else {
                console.log(res.errorMessage);
            }
        });
    }, []);

    const onClickRefreshSystemSettings = () => {
        SystemSettingsService.refresh().then((res: any) => {
            if (res && res.data && res.successful) {
                setSystemSettings(res.data);
            } else {
                console.log(res.errorMessage);
            }
        });
    };

    const onClickSaveSystemSettings = () => {
        SystemSettingsService.update({ body: systemSettings }).then(
            (res: any) => {
                if (res && res.data && res.successful) {
                    setSystemSettings(res.data);
                } else {
                    console.log(res.errorMessage);
                }
            }
        );
    };

    const onClickResetSystemSettings = () => {
        SystemSettingsService.clear().then((res: any) => {
            if (res && res.data && res.successful) {
                setSystemSettings(res.data);
            } else {
                console.log(res.errorMessage);
            }
        });
    };

    return (
        <div className="row">
            <div className="col-12">
                <div className="card" style={{ maxWidth: "100%", zIndex: 20 }}>
                    <div className="card-header">
                        <h4 className="card-title">System Settings</h4>
                        <div className="card-tools">
                            <div className="row d-flex justify-content-around">
                                <div className="col-sm-4">
                                    <button
                                        type="button"
                                        className="btn btn-primary center"
                                        onClick={onClickSaveSystemSettings}
                                    >
                                        Save
                                    </button>
                                </div>
                                <div className="col-sm-4">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={onClickRefreshSystemSettings}
                                    >
                                        Refresh
                                    </button>
                                </div>
                                <div className="col-sm-4">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={onClickResetSystemSettings}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="form-group row">
                            <div className="col-sm-6" id="dateInput">
                                <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                >
                                    <DateTimePicker
                                        label="Max DateTime For Queue"
                                        value={dayjs(
                                            systemSettings.maxDisplayedDateTime ??
                                                new Date()
                                        ).locale("America/NewYork")}
                                        onChange={(newValue, _) => {
                                            setSystemSettings({
                                                ...systemSettings,
                                                maxDisplayedDateTime:
                                                    newValue?.toDate(),
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-6">
                                    <label className="col-form-label">
                                        Hidden Attorney IDs
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows={10}
                                        value={JSON.stringify(
                                            systemSettings.hiddenAttorneyIds,
                                            null,
                                            4
                                        )}
                                        onChange={(e) => {
                                            // we need the parse the guid strings into actual guids
                                            // and deliniate them by new line
                                            // and ,
                                            // for example:
                                            // [
                                            //     00000000-0000-0000-0000-000000000000,
                                            //     11111111-1111-1111-1111-111111111111,
                                            //     22222222-2222-2222-2222-222222222222
                                            // ]
                                            const value = e.target.value;
                                            const guids = JSON.parse(value);
                                            setSystemSettings({
                                                ...systemSettings,
                                                hiddenAttorneyIds: guids,
                                            });
                                        }}
                                    ></textarea>
                                </div>
                                <div className="col-sm-6">
                                    <label className="col-form-label">
                                        Visible Attorney IDs
                                    </label>
                                    <textarea
                                        className="form-control"
                                        rows={10}
                                        value={JSON.stringify(
                                            systemSettings.visibleAttorneyIds,
                                            null,
                                            4
                                        )}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const guids = JSON.parse(value);
                                            setSystemSettings({
                                                ...systemSettings,
                                                visibleAttorneyIds: guids,
                                            });
                                        }}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
